module.exports = __webpack_public_path__ + "img/Construai-Borges.db542fce.png";